<span class="form-field">

  <label> {{label}} </label>

  <mat-form-field *ngIf="chips" appearance="outline" (click)="handleOpenPanel($event, trigger)"
    data-cy="custom-autocomplete">

    <mat-chip-grid #chipGrid>

      <mat-chip-row *ngFor="let item of selectedItems" (removed)="remove(item)">
        {{getDisplay(item)}}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>


      <input readonly matInput type="text" #trigger="matAutocompleteTrigger" [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
        class="bg-white"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [placeholder]="loading ? 'Carregando...' : 'Selecione'"
        [disabled]="loading"
        data-cy="custom-autocomplete-chip-values">

      @if (loading) {
      <mat-spinner diameter="20"></mat-spinner>
      }

    </mat-chip-grid>

  </mat-form-field>

  <mat-form-field *ngIf="!chips" appearance="outline" (click)="handleOpenPanel($event, trigger)">
    <input readonly matInput type="text" #trigger="matAutocompleteTrigger"[value]="displaySelectedItems()"
      placeholder="Selecione" [matAutocomplete]="auto" [attr.data-cy]="returnDataCy('custom-autocomplete-values')">
  </mat-form-field>

  <mat-autocomplete class="density-lower" #autoName="matAutocomplete" panelOpen="true" #auto="matAutocomplete"
    hideSingleSelectionIndicator>

    <mat-form-field appearance="outline" class="density-mat-form-3">
      @if (!singleSelect) {
        <mat-checkbox [checked]="allItemsSelected()" color="primary" class="check-all" (change)="toggleAll($event)">
          <input [attr.data-cy]="returnDataCy('custom-autocomplete-input')" type="text" matInput [formControl]="control"
          placeholder="Digite Aqui">
        </mat-checkbox>
      } @else {
          <input [attr.data-cy]="returnDataCy('custom-autocomplete-input')" type="text" matInput [formControl]="control"
          placeholder="Digite Aqui">
      }

    </mat-form-field>

    @if (loading) {
    <div>

      <mat-option class="loading-option-container" data-cy="returnDataCy('loader-container')">
        <mat-spinner diameter="20"></mat-spinner>
      </mat-option>
    </div>
    }

    <div [ngStyle]="{display: loading ? 'none' : 'block'}">
      <ng-container *ngIf="enableVirtualScroll; else defaultScroll">
        <cdk-virtual-scroll-viewport itemSize="50" [ngStyle]="{ display: noResults ? 'none' : 'block' }">
          <mat-option *cdkVirtualFor="let item of filteredItems | async"
            (click)="toggleSelection(item, !itemSelected(item))"
            [attr.data-cy]="returnDataCy('custom-autocomplete-options')">
            @if (!singleSelect) {
            <mat-checkbox #checkboxes color="primary" [checked]="itemSelected(item) || allItemsSelected()"
              (change)="toggleSelection(item, $event.checked)" (click)="$event.stopPropagation()">
              {{ getDisplay(item) }}
            </mat-checkbox>
            } @else {
              <div [ngClass]="{ 'selected-single-select': itemSelected(item)}">
                {{ getDisplay(item) }}
              </div>
            }
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </ng-container>
      <ng-template #defaultScroll>
        <mat-option *ngFor="let item of filteredItems | async" (click)="toggleSelection(item, !itemSelected(item))"
          [attr.data-cy]="returnDataCy('custom-autocomplete-options')">
          <mat-checkbox #checkboxes color="primary" [checked]="itemSelected(item) || allItemsSelected()"
            (change)="toggleSelection(item, $event.checked)" (click)="$event.stopPropagation()">
            {{ getDisplay(item) }}
          </mat-checkbox>
        </mat-option>
      </ng-template>

      <mat-option *ngIf="noResults" data-cy="returnDataCy('custom-autocomplete-no-results')">
        Sem resultados
      </mat-option>

      <!--   This *ngIf condition determine if the data fetched on the server is the same on filter
             Which is assigned during ngOnInit or on `handleOpenPanel` method when network delay.
      -->
      <mat-option *ngIf="!noResults && (filteredItems | async)?.length == 0" class="loading-option-container"
        data-cy="returnDataCy('loader-container')">
        <mat-spinner diameter="40"></mat-spinner>
      </mat-option>
    </div>

    <!-- Empty Mat option to allow show list when evaluating "syncing results" -->
    <mat-option style="display: none;"></mat-option>
  </mat-autocomplete>
</span>

<span *ngIf="list.length == 0 && !chips" class="form-field">
  <label> {{label}} </label>
  <mat-form-field appearance="outline">
    <input type="text" readonly [attr.data-cy]="returnDataCy('custom-autocomplete-values')" matInput>

    @if (loading) {
    <mat-spinner diameter="20"></mat-spinner>
    }

  </mat-form-field>
</span>
